import React, { useContext, useEffect, useState } from "react";
import BasicInput from "components/input/BasicInput";
import BasicTextarea from "components/input/BasicTextarea";
import BasicSelect from "components/input/BasicSelect";
import { v4 as uuidv4 } from "uuid";
import CommonCodeSelect from "components/input/CommonCodeSelect";
import UserModal from "components/modal/UserModal";
import { isEmpty } from "js/common";
import Float from "components/input/Float";
import DatePickerInput from "components/input/DatePickerInput";
import TimeInput from "components/input/TimeInput";


export default function MakeItemField({ item, resultData, initialData, setSearchDisabled, onEnterDown }) {
	const [data, setData] = useState({});
	const [searchDisabledArr, setSearchDisabledArr] = useState([]);	// 기간 조건일때 검색조건 비활성화 2개를 처리하기 위함.

	const [isOpenUserModal, setIsOpenUserModal] = useState(false);	//사용자 선택 (사원 번호)
	const [isOpenUserModal2, setIsOpenUserModal2] = useState(false);  //사용자 선택 (사원 번호, 이름)
	
	useEffect(() => {
		if(Array.isArray(item.col)) {
			const newData = {};
			for(const col of item.col) {
				if(initialData?.[col]) {
					newData[col] = initialData[col];
				}
			}
			if(!isEmpty(newData)) {
				setData(newData);
			}
		} else {
			if(initialData?.[item.col]) {
				setData({[item.col]: initialData[item.col]});
			}
		}
	}, [initialData]);

	useEffect(() => {
		resultData && resultData(data);
	}, [data])

	const inputChange = (e) => {
		const { value, name } = e.target;
		let val = value;
		setData((prevData) => ({
			...prevData,
			[name]: val,
		}));
	};

	const [checked, setChecked] = useState(false);

	const handleChecked = (e) => {
		const check = e.target.checked;
		setChecked(!checked);

		setData((prev)=> {
			return {...prev, [e.target.name] : !checked ? "Y" : "N"}
		})
	};

	const dateClick = (date, col) => {
		let val = date;
		setData((prevData) => ({
			...prevData,
			[col]: val,
		}));
	};

	// 기간검색일때 2개 모두 정상입력일때만 검색버튼 활성화 하기 위함.
	// 비활성 여부 Array에 담아줌
	const setSearchDisabledForTerm = (bool, idx) => {
		if(!setSearchDisabled) return;	// setSearchDisabled가 없으면 할 필요 없음.
		const newSearchDisableArr = [...searchDisabledArr];
		newSearchDisableArr[idx] = bool;
		setSearchDisabledArr(newSearchDisableArr);
	}
	// 비활성 Array에서 비활성이 한개라도 있으면 비활성. 아니면 활성.
	useEffect(() => {
		if(!setSearchDisabled) return;	// setSearchDisabled가 없으면 할 필요 없음.
		const disableItem = searchDisabledArr.filter((d) => d === true);
		if(disableItem.length > 0) setSearchDisabled(true);
		else setSearchDisabled(false);
	}, [searchDisabledArr]);

	const returnData=(data)=> {
		setData((prev)=> {
			return {...prev, empNo: data[0].empNo}
		});
		setIsOpenUserModal(false);
	}

	const delEmpNo=()=> {
		setData((prev)=> {
			return {...prev, empNo: ""}
		});
	}

	const getEmpNoAndName = (data) => {
		setData((prev)=> {
			return {...prev, empNo: data[0].empNo, userNm: data[0].userNm, userSeq: data[0].userSeq}
		});
		setIsOpenUserModal2(false);
	}

	const delEmpNoAndName = () => {
		setData((prev)=> {
			return {...prev, empNo: "", userNm: ""}
		});
	}

	// 엔터키 입력시 처리
	const onKeyDown = (e) => {
		if(e.keyCode === 13 && onEnterDown) {
			e.preventDefault();
			onEnterDown();
		}
	}

	const renderField = (item) => (
			item.type === "input" ? (
				//<BasicInput id="basicInput" item={item} onChange={inputChange} value={data?.[item.col] ?? ""} />
				<BasicInput id="basicInput" item={item} onChange={inputChange} value={data?.[item.col] ?? ""} readOnly={item.readOnly} onKeyDown={onKeyDown} />
			) : item.type === "dateAndTime" ? (
				<div className="date-picker-input-term">
					<div style={{width: "60%"}}>
					<DatePickerInput name={item.col[0]} value={data?.[item.col[0]] ?? ""} placeholder={item.placeholder} onChange={(e) => inputChange(e)} setSearchDisabled={(bool) => setSearchDisabledForTerm(bool, 0)} onKeyDown={onKeyDown} />
					</div>
					<div style={{width: "40%"}}>
					<TimeInput name={item.col[1]} value={data?.[item.col[1]] ?? ""} onChange={(e) => inputChange(e)}  />
					</div>
				</div>
			) : item.type === "dateAndTimeTerm" ? (
				<div className="date-picker-input-term">
					<div style={{width: "30%"}}>
						<DatePickerInput name={item.col[0]} value={data?.[item.col[0]] ?? ""} placeholder={item.placeholder} onChange={(e) => inputChange(e)} setSearchDisabled={(bool) => setSearchDisabledForTerm(bool, 0)} onKeyDown={onKeyDown} />
					</div>
					<div style={{width: "19%"}}>
						<TimeInput name={item.col[1]} value={data?.[item.col[1]] ?? ""} onChange={(e) => inputChange(e)}  />
					</div>
					~
					<div style={{width: "30%"}}>
						<DatePickerInput name={item.col[2]} value={data?.[item.col[2]] ?? ""} placeholder={item.placeholder} onChange={(e) => inputChange(e)} setSearchDisabled={(bool) => setSearchDisabledForTerm(bool, 0)} onKeyDown={onKeyDown} />
					</div>
					<div style={{width: "19%"}}>
						<TimeInput name={item.col[3]} value={data?.[item.col[3]] ?? ""} onChange={(e) => inputChange(e)}  />
					</div>
				</div>
			) : item.type === "dayPickerInputTerm" ? (
				<div className="date-picker-input-term">
					<DatePickerInput name={item.col[0]} value={data?.[item.col[0]] ?? ""} placeholder={item.placeholder} onChange={(e) => inputChange(e)} setSearchDisabled={(bool) => setSearchDisabledForTerm(bool, 0)} onKeyDown={onKeyDown} />
					&nbsp;~&nbsp;
					<DatePickerInput name={item.col[1]} value={data?.[item.col[1]] ?? ""} placeholder={item.placeholder} onChange={(e) => inputChange(e)} setSearchDisabled={(bool) => setSearchDisabledForTerm(bool, 1)} onKeyDown={onKeyDown} />
				</div>
			) : item.type === "datePicker" ? (
				<DatePickerInput type="DAY" name={item.col} value={data?.[item.col] ?? ""} placeholder={item.placeholder} onChange={(e) => inputChange(e)} setSearchDisabled={(bool) => setSearchDisabled(bool)} required={item.required ?? false} onKeyDown={onKeyDown} />
			) : item.type === "monthPicker" ? (
				<DatePickerInput type="MONTH" name={item.col} value={data?.[item.col] ?? ""} placeholder={item.placeholder} onChange={(e) => inputChange(e)} setSearchDisabled={(bool) => setSearchDisabled(bool)} required={item.required ?? false} onKeyDown={onKeyDown} />
			) : item.type === "yearPicker" ? (
				<DatePickerInput type="YEAR" name={item.col} value={data?.[item.col] ?? ""} placeholder={item.placeholder} onChange={(e) => inputChange(e)} setSearchDisabled={(bool) => setSearchDisabled(bool)} required={item.required ?? false} onKeyDown={onKeyDown} />
			) : item.type === "desc" ? (
				<BasicTextarea item={item} onChange={inputChange} value={data?.[item.col] ?? ""} />
			) : item.type === "number" ? (
				<Float
					// className="basic-input"
					name={item.col ?? ""}
					value={data?.[item.col] ?? ""}
					decimalPlaceCnt={0}
					onChange={inputChange}
				/>
			) : item.type === "select" ? (
				<BasicSelect item={item} onChange={inputChange} value={data?.[item.col] ?? ""} onKeyDown={onKeyDown} />
			) : item.type === "radio" ? (
				item.option && item.option.length > 0 && (
					// <div className="radio-container">
					<div style={{display: "flex"}}>
						{item.option.map((op, idx) => (
							<div key={uuidv4()} style={{display: "flex", alignItems: "center"}}>
								<input
									type="radio"
									id={item.col + "_" + op.value}
									name={item.col}
									value={op.value}
									checked={!data?.[item.col] && idx === 0 ? true : data?.[item.col] === op.value}
									onChange={inputChange}
								/>
								<label htmlFor={item.col + "_" + op.value}>{op.label}</label>
							</div>
						))}
					</div>
				)
			) : item.type === "commonCodeSelect" ? (
				<CommonCodeSelect item={item} onChange={inputChange} value={data?.[item.col] ?? ""} grpCd={item.grpCd} except={item.except} valNm={item.valNm ? item.valNm : false} addDefault={item.addDefault} defaultLabel="전체" onKeyDown={onKeyDown} />
			) : item.type === "checkbox" ? (
				<>
					<div style={{display: "flex", alignItems: "center"}} onKeyDown={onKeyDown}>
						<input type="checkbox" id={"search_" + (item.id ?? item.col)} name={item.col}  checked={checked} onChange={handleChecked} ></input>
						<label htmlFor={"search_" + (item.id ?? item.col)} className="mg-l-5">{item.label}</label>
					</div>
				</>
			): null
	);
	
	return (
		<>
			{renderField(item)}
			{/* {isOpenModalProject && <ProjectModal width={550} height={770} title="프로젝트 목록" onClose={() => setIsOpenModalProject(false)} returnInfo={setProjectInfo} />}
			<CompanyModal width={500} height={550} title="거래처 목록" isOpen={isOpenModalCompany} onClose={() => setIsOpenModalCompany(false)} />
			<ProductInfoModal width={600} height={770} title="품목정보 목록" isOpen={isOpenModalProductInfo} onClose={() => setIsOpenModalProductInfo(false)} />
			<ProductGroupModal width={600} height={720} title="품목그룹 목록" isOpen={isOpenModalProductGroup} onClose={() => setIsOpenModalProductGroup(false)} />
			<EmployerInfoModal width={600} height={770} title="업무회원 목록" isOpen={isOpenModalEmployerInfo} onClose={() => setIsOpenModalEmployerInfo(false)}  colName={colName}/> */}
			<UserModal title="사용자선택" returnData={returnData} singleSelectOnly={true} isOpen={isOpenUserModal} onClose={()=> setIsOpenUserModal(false)} />
			<UserModal title="사용자선택" returnData={getEmpNoAndName} singleSelectOnly={true} isOpen={isOpenUserModal2} onClose={()=> setIsOpenUserModal2(false)} />

		</>
	);
}
